import { forwardRef } from 'react';
import { ButtonBase } from './ButtonBase.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import { jsx } from 'react/jsx-runtime';

const LinkButton = /*#__PURE__*/forwardRef(({
  children,
  as: Component = 'a',
  sx = defaultSxProp,
  ...props
}, forwardedRef) => {
  return /*#__PURE__*/jsx(ButtonBase, {
    as: Component,
    ref: forwardedRef,
    sx: sx,
    ...props,
    children: children
  });
});

export { LinkButton };
